
let initialized = false;

const initNotices = () => {
    if (initialized) {
        return;
    }

    const notices = document.querySelectorAll('.alert.alert-info');

    if (notices.length === 0) {
        return;
    }

    initialized = true;

    // Find notices and dismiss them after 5 seconds
    notices.forEach(function(notice) {
        const btn = notice.querySelector('button.btn-close');
        if (btn) {
            setTimeout(() => btn.click(), 5000);
        }
    });
}

document.addEventListener("DOMContentLoaded", initNotices);
document.addEventListener("turbo:load", initNotices);
